<div>
  <div class="gb-dialog-header">
    <h1 translate="PROJECTOR.ADD_PROJECTOR"></h1>
    <button mat-dialog-close mat-button><gb-icon icon="close"></gb-icon></button>
  </div>
  <div class="gb-dialog-content">
    <form [formGroup]="projectorContainerFormGroup">
      <gb-form-field labelTranslateKey="PROJECTOR.PROJECTOR_NAME" [control]="name"> </gb-form-field>

      <gb-select-form-field
        labelTranslateKey="PRESENTER.ASPECT_RATIO"
        [options$]="aspectRatios$"
        [control]="aspect_ratio"
        valueProperty="value"
        displayProperty="label"
      >
      </gb-select-form-field>

      <mat-checkbox [formControl]="useTemplate">
        {{ 'PROJECTOR.USE_TEMPLATE' | translate }}
      </mat-checkbox>

      @if (useTemplate.value) {
        <div class="gb-template-section">
          <div class="gb-template-section-inner">
            <gb-presenter-templates-list></gb-presenter-templates-list>
          </div>
        </div>
      }
    </form>
  </div>

  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button (click)="onSubmit()" mat-flat-button>
      <gb-button-loader [loaded$]="createEditLoaded$">
        <span translate="CREATE"></span>
      </gb-button-loader>
    </button>
  </div>
</div>
